import React from 'react'
import Constant from '../Constant'
import axios from 'axios'
import Swal from 'sweetalert2'
class CaptainDashboard extends React.Component {
  state = {
    total_boats: 0,
    captain: 0,
    orders: 0,
    activity: 0,
  }
  componentDidMount() {
    this.dashbord()
  }

  dashbord = async () => {
    var that = this

    await axios
      .get(Constant.getAPI() + '/user/dashboard', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            total_boats: res.data.data.total_boats,
            orders: res.data.data.total_orders,
            Data: res.data.data.role_counts,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Dashboard</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-green f-w-600">{this.state.total_boats}</h4>
                          <h6 className="text-muted m-b-0">Total Boats</h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="icofont icofont-sail-boat-alt-1"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-green"></div>
                  </div>
                </div>

                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-blue f-w-600">{this.state.orders}</h4>
                          <h6 className="text-muted m-b-0">Total Orders</h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="icofont icofont-cart-alt f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-blue"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="styleSelector"></div>
        </div>
      </div>
    )
  }
}
export default CaptainDashboard
